import classNames from 'classnames';
import { DrawerPositions, GetDrawerStylesProps, DrawerLayoutVariants } from '../drawer-types';
import styles from '../drawer.module.scss';

export const getDrawerStyles = ({
  drawerPosition,
  layoutVariant,
  showVeil,
  isOpen,
  addClass,
}: GetDrawerStylesProps): string => {
  return classNames(
    styles.container,
    styles[drawerPosition as string],
    styles[layoutVariant as string],
    {
      [styles.layoutAbsolute]:
        drawerPosition === DrawerPositions.Bottom && layoutVariant === DrawerLayoutVariants.Absolute,
      [styles.layoutFull]: drawerPosition === DrawerPositions.Bottom && layoutVariant === DrawerLayoutVariants.Full,
      [styles.layoutLimited]:
        drawerPosition === DrawerPositions.Bottom && layoutVariant === DrawerLayoutVariants.Limited,
    },
    !showVeil && !isOpen && styles.hide,
    addClass,
  );
};
